export enum Case {
    /**
     * родительный
     */
    Genitive,
    /**
     * дательный
     */
    Dative,
    /**
     * винительный
     */
    Accusative,
    /**
     * творительный
     */
    Instrumental,
    /**
     * предложный
     */
    Prepositional, //предложный
}
